import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CustomDropdown from '@components/CustomDropdown';
import { toastError } from '@components/Toast';

import TeamChip from '@features/filter/Common/TeamChip';
import { isTeamFilterExist } from '@features/filter/static/filterUtil';
import UsersForTeamLead from '@features/filter/v1/core/UsersForTeamLead';

import { fetchBrandList } from '@store/actions/BrandAction';
import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { setSampleRequestFilterField } from '@store/actions/SampleAction';
import { clearTeamFilter } from '@store/actions/TeamMemberAction';
import { fetchUserList } from '@store/actions/UserAction';

import ApiClient from '@lib/apiClient';

import { checkAnyUserType } from '@utils/Util';

const SampleTopFilter = ({ onSetpage, requestFrom, additionalData }) => {
	const [showSearchBox, setShowSearchBox] = useState(false);
	const brandStore = useSelector((store) => store.brandStore);
	const userStore = useSelector((store) => store.userStore);
	const [brandList, setBrandList] = useState([]);
	const [collectionList, setCollectionList] = useState([]);
	const [countryList, setCountryList] = useState([]);
	const [departmentList] = useState([
		{ id: 'DESIGN', value: 'Design' },
		{ id: 'OTHERS', value: 'BIZ, PD & Merchandiser' }
	]);
	const [userList, setUserList] = useState([]);
	const dispatch = useDispatch();
	const [inputData, setInputData] = useState({});
	const sampleStore = useSelector((store) => store.sampleStore);
	const myTeamMembers = useSelector((store) => store.teamMembersReducer);

	const fetchCollectionList = async (search) => {
		let params = search !== undefined ? `SAMPLE?search=${search}` : 'SAMPLE';
		await ApiClient.GET('fetchCollectionForSample', params)
			.then(({ data }) => {
				let lists = [];
				data.data.map((item) => lists.push({ id: item.id, value: item.name }));
				setCollectionList(lists);
			})
			.catch(() => {
				toastError('Unable to fetch collection list!');
			});
	};

	const fetchCountryList = () => {
		ApiClient.GET('getCountryListByUnits', 'SAMPLE_HOUSE')
			.then(({ data }) => {
				let lists = [];
				data.map((item) => lists.push({ id: item.id, value: item.name }));
				setCountryList(lists);
			})
			.catch(() => {
				toastError('Unable to fetch Country list!');
			});
	};

	useEffect(() => {
		fetchCollectionList();
		fetchCountryList();
		dispatch(fetchBrandList());
		dispatch(fetchUserList());
		return () => {
			dispatch(setSampleRequestFilterField({}));
		};
	}, []);

	useEffect(() => {
		if (brandStore.length > 0) {
			let brands = [];
			brandStore.map((brand) => brands.push({ id: brand.id, value: brand.name }));
			setBrandList(brands);
		}
	}, [brandStore]);

	useEffect(() => {
		if (userStore.length > 0) {
			let users = [];
			userStore.map((user) => users.push({ id: user.id, value: user.name }));
			setUserList(users);
		}
	}, [userStore]);

	const handleChange = (e) => {
		let cloneObj = {
			...inputData,
			collection: { ...inputData.collection },
			user: { ...inputData.user },
			brand: { ...inputData.brand },
			search: e.target.value
		};
		setInputData(cloneObj);
		handleFilter(cloneObj);
		if (onSetpage) {
			onSetpage();
		}
	};

	const handleDropDown = (item) => {
		let cloneObj = {
			...inputData,
			collection: { ...inputData.collection },
			country: { ...inputData.country },
			user: { ...inputData.user },
			brand: { ...inputData.brand },
			department: { ...inputData.department }
		};

		if (item?.title !== undefined) {
			let key;
			if (item.title === 'Collection') {
				key = 'collection';
			} else if (item.title === 'Country') {
				key = 'country';
			} else if (item.title === 'Brand') {
				key = 'brand';
			} else if (item.title === 'All department') {
				key = 'department';
			} else {
				key = 'user';
			}
			cloneObj[key] = {
				id: item.id,
				value: item.value
			};
			setInputData(cloneObj);
			handleFilter(cloneObj);
			if (onSetpage) {
				onSetpage();
			}
		}
	};

	const handleFilter = (cloneObj) => {
		let postData = {};
		if (cloneObj?.search) {
			postData.search = cloneObj.search;
		}
		if (cloneObj?.country?.id) {
			postData.country = cloneObj.country;
		}
		if (cloneObj?.collection?.id) {
			postData.collection = cloneObj.collection;
		}
		if (cloneObj?.brand?.id) {
			postData.brand = cloneObj.brand;
		}
		if (cloneObj?.user?.id) {
			postData.requestBy = cloneObj.user;
		}
		if (cloneObj?.department?.id) {
			postData.department = cloneObj.department;
		}
		if (requestFrom === 'CRM') {
			postData = { ...postData, ...additionalData };
		}
		dispatch(setSampleRequestFilterField(postData));
	};

	const onUserSearch = (value) => dispatch(fetchUserList(value));

	const renderUserFilterField = () => {
		if (!checkAnyUserType(['FASHION_DESIGNER', 'ACCOUNT_MANAGER'])) {
			return (
				<div className="single-filter">
					<CustomDropdown
						type="addItem"
						title={'Requested By'}
						onItemClick={handleDropDown}
						items={userList}
						selectedItem={sampleStore?.filterField?.requestBy?.value}
						onItemSearch={onUserSearch}
					/>
				</div>
			);
		}
	};

	const handleSearch = (value) => {
		dispatch(openLoader());
		fetchCollectionList(value).finally(() => dispatch(closeLoader()));
	};

	const isShowClear = () => {
		return Object.keys(sampleStore.filterField).length > 0;
	};

	const clearFilter = () => {
		dispatch(clearTeamFilter());
		if (requestFrom === 'CRM') {
			dispatch(setSampleRequestFilterField({ ...additionalData }));
		} else {
			dispatch(setSampleRequestFilterField({}));
		}
		setInputData({});
	};

	const handleCrm = () => {
		if (requestFrom === 'CRM') {
			return Object.keys(sampleStore?.filterField).length > 1 || isTeamFilterExist(myTeamMembers);
		} else {
			return true;
		}
	};

	return (
		<div className="filter-container-top pt-2 pb-2 bg-gray">
			{requestFrom !== 'CRM' && (
				<div className="filters">
					<div className="samples-summary">
						{sampleStore?.countResponse && (
							<span>{sampleStore?.countResponse?.noOfSampleRequest} Request</span>
						)}
						{sampleStore?.countResponse && (
							<span>{sampleStore?.countResponse?.noOfDesign} Design</span>
						)}
						{sampleStore?.countResponse && (
							<span>{sampleStore?.countResponse?.quantity} Pcs</span>
						)}
						{sampleStore?.countResponse && (
							<span>{sampleStore?.countResponse?.noOfDeliveredDesign} Design delivered</span>
						)}
					</div>
					<TeamChip />
				</div>
			)}
			<div className="filter-actions sample-dashboard-filter">
				{handleCrm() && (isShowClear() || isTeamFilterExist(myTeamMembers)) && (
					<span className="clear-btn" onClick={clearFilter}>
						Clear
					</span>
				)}
				<div className="form-group size32 m-0 search-filter filter-with-animation">
					<div className={!showSearchBox ? 'with-icon right-icon hidden' : 'with-icon right-icon'}>
						<input
							type="text"
							placeholder="Design name & number"
							name="search"
							value={sampleStore?.filterField?.search || ''}
							onChange={handleChange}
							autoComplete="off"
						/>
						<span
							className="right-icon"
							onClick={() => setShowSearchBox((prevState) => !prevState)}
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width={23}
								height={22}
								viewBox="0 0 23 22"
								fill="none"
							>
								<path
									d="M10.543 16.5C14.3399 16.5 17.418 13.422 17.418 9.625C17.418 5.82804 14.3399 2.75 10.543 2.75C6.74601 2.75 3.66797 5.82804 3.66797 9.625C3.66797 13.422 6.74601 16.5 10.543 16.5Z"
									stroke="#21242B"
									strokeWidth="1.5"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
								<path
									d="M19.2526 18.3346L15.5859 14.668"
									stroke="#21242B"
									strokeWidth="1.5"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
							</svg>
						</span>
					</div>
				</div>

				<UsersForTeamLead />
				<div className="single-filter">
					<CustomDropdown
						type="addItem"
						title={'Collection'}
						onItemSearch={handleSearch}
						onItemClick={handleDropDown}
						items={collectionList}
						selectedItem={sampleStore?.filterField?.collection?.value}
					/>
				</div>
				<div className="single-filter">
					<CustomDropdown
						type="addItem"
						title={'Country'}
						onItemSearch={() => false}
						onItemClick={handleDropDown}
						items={countryList}
						selectedItem={sampleStore?.filterField?.country?.value}
					/>
				</div>
				{renderUserFilterField()}
				<div className="single-filter">
					<CustomDropdown
						type="addItem"
						title={'All department'}
						onItemClick={handleDropDown}
						items={departmentList}
						selectedItem={sampleStore?.filterField?.department?.value}
					/>
				</div>
				{requestFrom !== 'CRM' && (
					<div className="single-filter">
						<CustomDropdown
							type="addItem"
							title={'Brand'}
							isShowLabel={false}
							onItemClick={handleDropDown}
							items={brandList}
							selectedItem={sampleStore?.filterField?.brand?.value}
						/>
					</div>
				)}
			</div>
		</div>
	);
};

export default SampleTopFilter;
